import { setStore, getStore } from '@/util/store';
const data = {
    //项目中的数据保存store
    state: {
      step2Info:[],//数据导入中第二步表格数据
    },
    mutations: {
        SET_step2Info:(state, step2Info) => {
            state.step2Info = step2Info;
            setStore({
                name: 'step2Info',
                content: state.step2Info,
                type: 'session',
            });
            },
        }
  };
  
  export default data;